module.exports = __webpack_public_path__ + "static/media/graves.87fc11af.png";